<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c06"><a id="page07"></a>Wedding Blitz</h1>
<p class="nonindent"><span class="dropcaps">H</span>ollywood celebrities are known for having short marriages—just think of Britney Spears’s fifty-five hour union. But even that couldn’t top one of the shortest marriages on record—ninety minute s. In June 2003, after a whirlwind eight-week romance, Scott McKie and Victoria Anderson tied the knot, and then Scott tied one on. During their reception at an upscale pub, Scott started to behave “disgracefully” and was “drinking like a Russian fish.” McKie scrambled on top of a table and gave a toasted “toast” to his wife’s bridesmaids and made suggestive comments to some of the female guests. To show her appreciation, Vicky christened her new husband over the head with an ashtray. When the bartender cut him off, Scott grabbed a hat stand and threw it javelin style at a largemirror. The number of wedding guests increased when the police arrived, and Scott greeted them, not with a handshake, but with a head butt. While Scott was being dragged down the aisle to jail, Vicky canceled their honeymoon reservations and started the divo rce proceedings. Total marriage time: ninety minute s. Memories that will last a lifetime: Priceless.<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c06_r1.vue?27198cc9